import VConsole from "vconsole";

// export default new VConsole();

export default defineNuxtPlugin((nuxtApp) => {
  if (useRuntimeConfig().public.vitenodeenv !== "prod") {
    // 线上环境中不引入
    const vConsole = new VConsole();
  }
});
